export default "__VITE_ASSET__14c767ed__"